"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _themes = require("../themes");
var _createMediaQueries = _interopRequireDefault(require("./createMediaQueries"));
// Default values
var _getTheme = (0, _themes.getTheme)(),
  breakpoints = _getTheme.breakpoints;
var mediaQueries = (0, _createMediaQueries.default)(breakpoints);
var BreakpointContext = /*#__PURE__*/_react.default.createContext({
  breakpoints: breakpoints,
  mediaQueries: mediaQueries
});
var _default = exports.default = BreakpointContext;